export type AppDataType =
  | "dateTime"
  | "date"
  | "percentage"
  | "amount"
  | "string"
  | "boolean"
  | "code"
  | "codes"
  | "float"
  | "gps"
  | "integer"
  | "stringList"
  | "stringMap"
  | "vertexId"
  | "vertexIdList";

export type TypedValue =
  | { type: "amount"; value: number }
  | { type: "percentage"; value: number }
  | { type: "float"; value: number }
  | { type: "integer"; value: number }
  | { type: "string"; value: string }
  | { type: "code"; value: string }
  | { type: "date"; value: Date }
  | { type: "dateTime"; value: Date }
  | { type: "boolean"; value: boolean }
  | { type: "codes"; value: string }
  | { type: "gps"; value: string }
  | { type: "stringList"; value: string }
  | { type: "stringMap"; value: string }
  | { type: "vertexId"; value: string }
  | { type: "vertexIdList"; value: string };

export type SelectTypedValue<TType extends AppDataType> = Extract<TypedValue, { type: TType }>;

export const hasType = <TType extends AppDataType>(
  value: TypedValue,
  type: TType
): value is SelectTypedValue<TType> => value.type === type;
